import { render, staticRenderFns } from "./SetNumber.vue?vue&type=template&id=1ce01981"
import script from "./SetNumber.vue?vue&type=script&lang=js"
export * from "./SetNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports